import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ApplicationItem, ApplicationSearchParams, RequestStrategyEnum } from '@shared/api';

interface IApplicationsStore {
  loading: boolean;
  error: string | null;
  applications: ApplicationItem[];
  getApplications: (searchParams?: ApplicationSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationsStore = create<IApplicationsStore>((set) => ({
  loading: false,
  error: null,
  applications: [],

  getApplications: ApiUtils.wrapperApi(async (searchParams: ApplicationSearchParams = {}, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.getApplications(searchParams, signal);
      set({ applications: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ applications: [], loading: false, error: null }),
}));
